import React from 'react'
import { TabContent, TabPane } from 'reactstrap'


export default class ReviewsCarousel extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            active: 0,
            max: this.props.reviews.length - 1
        }
        this.stars = this.range(5)
    }

    componentDidMount() {
        this.doRotate()
    }

    range = (N) => {
        return Array.from(Array(N).keys()).map(k => k + 1)
    }

    renderStars = rating => {
        const fullStars = Math.ceil(rating / 2)
        return (
            <div className="float-right text-nowrap">
                {this.stars.map(x =>
                    <React.Fragment key={x}>
                        <i className={`fa fa-star ${x <= fullStars ? 'text-warning' : ''}`}></i>{' '}
                    </React.Fragment>
                )}
            </div>
        )
    }

    doRotate = () => {
        setTimeout(() => {
            this.setState({active: this.state.active < this.state.max ? this.state.active + 1 : 0})
            this.doRotate()
        }, this.props.timer_ms);

    }


    render() {
        return (
            <TabContent activeTab={`review_${this.state.active}`}>
                {this.props.reviews.map((r, idx) =>
                    <TabPane key={`review_${idx}`} tabId={`review_${idx}`}>
                        <div lang={r.locale}>{r.message}</div>
                        <div className="float-left text-nowrap font-weight-bold">{r.name}</div>
                        {this.renderStars(r.rating)}
                    </TabPane>
                )}
            </TabContent>
        )
    }
}